module.exports = __webpack_public_path__ + "images/emoji/innocent.cbcb977eddedbae655e5.png";